export const ON_BOARDING_FORM_STEPS = {
  COMPANY_BASIC_INFO_ID: 1,
  COMPANY_OVER_VIEW_ID: 2,
  OBJECTIVES_FORM_ID: 3,
  CHALLENGES_FORM_ID: 4,
} as const

export const ON_BOARDING_STEPS_CONFIG = [
  {
    formKey: 1,
    nextStepFormKey: 2,
    stepID: ON_BOARDING_FORM_STEPS.COMPANY_BASIC_INFO_ID,
    nextStepID: ON_BOARDING_FORM_STEPS.COMPANY_OVER_VIEW_ID,
    formName: 'companyBasicInfoFrom',
  },
  {
    formKey: 2,
    nextStepFormKey: 3,
    stepID: ON_BOARDING_FORM_STEPS.COMPANY_OVER_VIEW_ID,
    nextStepID: ON_BOARDING_FORM_STEPS.OBJECTIVES_FORM_ID,
    formName: 'companyOverViewForm',
  },
  {
    formKey: 3,
    nextStepFormKey: 4,
    stepID: ON_BOARDING_FORM_STEPS.OBJECTIVES_FORM_ID,
    nextStepID: ON_BOARDING_FORM_STEPS.CHALLENGES_FORM_ID,
    formName: 'objectivesForm',
  },
  {
    formKey: 4,
    nextStepFormKey: null,
    stepID: ON_BOARDING_FORM_STEPS.OBJECTIVES_FORM_ID,
    nextStepID: null,
    formName: 'challengesForm',
  },
] as const
